import { useTranslation } from "react-i18next"
import { FilterContainer } from "../components/FilterContainer"
import { SearchBar } from "../components/navbar/SearchBar"
import { ListingListView } from "../components/listing/ListingListView";
import { ListingListViewCarousel } from "../components/listing/ListingListViewCarousel";
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HandymanIcon from '@mui/icons-material/Handyman';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import LanguageSelector from "../components/main_page/LanguageSelector"
import { MainMenuButton } from "../components/navbar/MainMenuButton"
import { useAppSelector } from "../store/hooks"
import { PrimaryButton } from "../components/buttons/PrimaryButton";
import { useNavigate } from "react-router-dom";
import logo from '../assets/images/Rentic_logo.svg';
import { NavLink } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { DisplayType } from "../store/features/displaySlice";
import { Helmet } from "react-helmet-async";

export const TermsOfService: React.FC = () => {
    const { t } = useTranslation("main");
    const user = useAppSelector(state => state.auth.user);
    const navigate = useNavigate();

    const searchBarRef = useRef<HTMLDivElement | null>(null);
    const isCollidingRef = useRef(false); // Ref to store the latest collision state
    const [searchBarColliding, setSearchBarColliding] = useState(false);

    const displayType = useAppSelector((state) => state.display.type);

    return (
        <div className="flex flex-col text-left pt-[80px]">

            <Helmet>
                <title>Rentic - Teenustingimused</title>
                <meta name="description" content="Rentic rendiplatformi teenustingimused" />
                <meta name="keywords" content="rentic, teenustingimused, terms of service" />
                <meta property="og:title" content="Rentic - Minu Renti Pandud" />
                <meta property="og:description" content="Rentic rendiplatformi teenustingimused" />
                <meta property="og:image" content="/logo512.png" />
                <meta property="og:url" content="https://rentic.ee/my_rentals_status" />
            </Helmet>

            <h3><span>1. Kasutustingimused</span></h3>
            <p><span>Kasutustingimused</span></p>
            <p><span>Käesolevad kasutustingimused reguleerivad Rentic OÜ (edaspidi „Ettevõte“) poolt hallatava veebiplatvormi (edaspidi „Platvorm“) kasutamist. Kasutades Platvormi, kinnitate, et nõustute tingimustega.</span></p>

            <h4><span>2. Ettevõtte andmed</span></h4>
            <p><span>Rentic OÜ<br />Aadress: Võru maakond, Võru vald, Verijärve küla, Kose tee 55, 65541<br />Registrikood: 17097959<br />E-post: <a href="mailto:info@rentic.ee">info@rentic.ee</a></span></p>

            <h4><span>3. Platvormi kasutamine</span></h4>
            <ul>
                <li><span>Kasutajad saavad luua kontosid, postitada kuulutusi ja sõlmida omavahelisi rendilepinguid.</span></li>
                <li><span>Ettevõte ei ole renditehingute osapool ja ei vastuta rendilepingu täitmise eest.</span></li>
                <li><span>Kasutajad vastutavad enda pakutavate kuulutuste ja nende sisuga seotud täpsuse eest.</span></li>
            </ul>

            <h4><span>4. Tasud ja teenused</span></h4>
            <ul>
                <li><span>Kuulutuste lisamine: Platvormile kuulutuse lisamine on tasuline. Täpne hinnakiri on kättesaadav Platvormi hinnakirja lehel.</span></li>
                <li><span>Reklaami edendamine: Kasutajad saavad soovi korral tasuda oma kuulutuste esiletõstmiseks või reklaamimiseks.</span></li>
                <li><span>Kõik tasud tuleb tasuda enne teenuse aktiveerimist.</span></li>
            </ul>

            <h4><span>5. Kasutaja vastutus</span></h4>
            <ul>
                <li><span>Kasutajad on kohustatud esitama tõeseid andmeid ja hoiduma petlikust või eksitavast teabest.</span></li>
                <li><span>Kasutajad vastutavad kõikide Platvormil tehtud tehingutega seotud kohustuste ja kulude eest.</span></li>
                <li><span>Kõik vaidlused, mis tulenevad kasutajate vahel sõlmitud rendilepingutest, lahendatakse kasutajate endi vahel.</span></li>
            </ul>

            <h4><span>6. Ettevõtte vastutusest loobumine</span></h4>
            <ul>
                <li><span>Ettevõte ei vastuta kasutajate vahel sõlmitud kokkulepete täitmise, võimalike kahjustuste või muude kaudsete kahjude eest.</span></li>
                <li><span>Ettevõte teeb mõistlikke pingutusi Platvormi turvalisuse tagamiseks, kuid ei garanteeri Platvormi tõrgeteta tööd.</span></li>
            </ul>

            <h4><span>7. Tasumine ja tagastuspoliitika</span></h4>
            <ul>
                <li><span>Kõik tasud tuleb tasuda vastavalt Platvormil kuvatud maksejuhistele.</span></li>
                <li><span>Tasutud summasid ei tagastata, välja arvatud juhul, kui teenuse osutamine on Ettevõtte süül võimatuks osutunud.</span></li>
            </ul>

            <h4><span>8. Vaidluste lahendamine</span></h4>
            <p><span>Kõik Platvormi kasutamisest tulenevad vaidlused lahendatakse Eesti Vabariigi seaduste alusel.</span></p>

            <h4><span>9. Kontakt</span></h4>
            <p><span>Küsimused ja tagasiside kasutustingimuste kohta: <br />E-post: <a href="mailto:info@rentic.ee">info@rentic.ee</a></span></p>

        </div>
    )
}